/**
 * Created by MBENBEN on 2017/6/29.
 */
var d3T=require("d3-time-format");
module.exports=function (time,formatStr) {
    return d3T.timeFormat(formatStr)(time);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_lmw-time-format@1.0.1@lmw-time-format/main.js
// module id = 645
// module chunks = 378